import React from "react";
import { Head, Scheduler } from "../../components";
import "./standard_class.css";

export const Standard_class = () => {
  return (
    <>
      <div className="schedule-g">
        <Head title="Sesiones Regulares" />
        <Scheduler type="REGULAR"/>
      </div>
    </>
  );
}

export default Standard_class;